import { Component } from '@angular/core';
import { LsqBasePaginationComponent } from '../../base-pagination/lsq-base-pagination.component';

/**
 * Table pagination component
 *
 * @export
 * @class LsqMobileTableCardPaginationComponent
 */
@Component({
    selector: 'lsq-mobile-table-card-pagination',
    styleUrls: ['lsq-mobile-table-card-pagination.component.scss'],
    template: `
        <ng-container *ngIf="pageCount && pageCount > 1">
            <div class="mobile-paging d-flex justify-content-between">
                <button
                    id="prev-page"
                    class="btn btn-link go-to-page"
                    (click)="goToFirstPage()"
                    [disabled]="currentPage === 1"
                    [ngClass]="{ invisible: currentPage === 1 }"
                >
                    <lsq-icon [type]="icons.FirstPage" [color]="color.White"></lsq-icon>
                </button>
                <button
                    id="prev-page"
                    class="btn btn-link page-change"
                    (click)="incrementPage(paging.prev)"
                    [disabled]="currentPage === 1"
                    [ngClass]="{ invisible: currentPage === 1 }"
                >
                    <lsq-icon [type]="icons.ChevronLeft" [color]="color.White"></lsq-icon>
                </button>
                <span class="page-number">Page {{ currentPage }}</span>
                <button
                    id="next-page"
                    class="btn btn-link page-change"
                    (click)="incrementPage(paging.next)"
                    [disabled]="currentPage === pageCount"
                    [ngClass]="{ invisible: currentPage === pageCount }"
                >
                    <lsq-icon [type]="icons.ChevronRight" [color]="color.White"></lsq-icon>
                </button>
                <button
                    id="next-page"
                    class="btn btn-link go-to-page"
                    (click)="goToLastPage()"
                    [disabled]="currentPage === pageCount"
                    [ngClass]="{ invisible: currentPage === pageCount }"
                >
                    <lsq-icon [type]="icons.LastPage" [color]="color.White"></lsq-icon>
                </button>
            </div>
        </ng-container>
    `
})
export class LsqMobileTableCardPaginationComponent extends LsqBasePaginationComponent {
    public goToFirstPage(): void {
        const newSkip = 0;
        this.handlePageChange(this.getPageFromTakeAndSkip(this.take, newSkip));
    }

    public goToLastPage(): void {
        this.handlePageChange(this.pageCount);
    }
}
